import { useDispatch, useSelector } from "react-redux";
import { login } from "../../redux/slices/authSlice";
import { useEffect, useState } from "react";
import {
    Alert,
    Box,
    Button,
    Paper,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function LoginPage() {
    const dispatch = useDispatch();
    const nav = useNavigate();
    const { token, loading, error } = useSelector((s) => s.auth);
    const [identifier, setIdentifier] = useState("");
    const [password, setPassword] = useState("");

    useEffect(() => {
        if (token) nav("/dashboard/fbs", { replace: true });
    }, [token, nav]);

    async function onSubmit(e) {
        e.preventDefault();
        await dispatch(login({ identifier, password }));
    }

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: "#f3f4f6",
                p: 2,
            }}
        >
            <Paper sx={{ p: 3, width: 360 }}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    Вход
                </Typography>
                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}
                <form onSubmit={onSubmit}>
                    <Stack spacing={2}>
                        <TextField
                            label="Email"
                            type="email"
                            value={identifier}
                            onChange={(e) => setIdentifier(e.target.value)}
                            required
                            autoFocus
                        />
                        <TextField
                            label="Пароль"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <Button type="submit" variant="contained" disabled={loading}>
                            {loading ? "Входим…" : "Войти"}
                        </Button>
                    </Stack>
                </form>
            </Paper>
        </Box>
    );
}
